import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCursor1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCursor1"><Path d="M23.7736 9.86395L2.00195 2.00195L9.86395 23.7736L14.0973 14.0973L23.7736 9.86395Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCursor1;
